import { AlternateAppointmentTimesUsersourceFactory } from './alternate_appointment_times_usersource';
import { AppointmentAvailableTimesUsersourceFactory } from './appointment_available_times_usersource';
import { AppointmentLocationsOrganizersUsersourceFactory } from './appointment_location_staff_usersource';
import { AppointmentReasonUsersourceFactory } from './appointment_reason_usersource';

angular
  .module('capability-ng-appointments')
  .factory('ngAlternateAppointmentTimesUsersource', AlternateAppointmentTimesUsersourceFactory)
  .factory('ngAppointmentAvailableTimesUsersource', AppointmentAvailableTimesUsersourceFactory)
  .factory('ngAppointmentLocationsOrganizersUsersource', AppointmentLocationsOrganizersUsersourceFactory)
  .factory('ngAppointmentReasonUsersource', AppointmentReasonUsersourceFactory);

export * from './alternate_appointment_times_usersource';
export * from './appointment_available_times_usersource';
export * from './appointment_location_staff_usersource';
export * from './appointment_reason_usersource';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/usersources/usersources_module.ts